import "./FlagList.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { format } from "date-fns";

import { SlideFlag, LabOrder } from "pwapi";

import joinWithCommas from "shared/utils/joinWithCommas";
import { splitFlagReason } from "shared/utils/labOrderUtils";
import { getStainByLabStainId } from "shared/utils/stainUtils";

import { useAppSelector } from "store/hooks";

const FlagList = ({
  flags,
  labOrders,
}: {
  flags: SlideFlag[];
  labOrders: LabOrder[];
}) => {
  const labStains = useAppSelector(({ labStains }) => labStains);
  const stains = useAppSelector(({ stains }) => stains);

  return (
    <div className="FlagListWrapper">
      <div className="FlagList">
        {[...flags]
          .sort((flagA, flagB) =>
            (flagA.created_at || "") > (flagB.created_at || "") ? -1 : 1
          )
          .map((flag) => {
            const createdAt =
              flag.created_at &&
              format(new Date(flag.created_at), "MM/dd/yyyy");

            const order = labOrders.find((o) => o.id === flag.order_id);

            return (
              <div key={flag.id} className="FlagListItem">
                <FontAwesomeIcon icon="flag" color="var(--imperialRed)" />
                <div className="flag__container">
                  <div className="flag__information">
                    {createdAt}
                    <span>
                      {flag.user?.first_name} {flag.user?.last_name}
                    </span>
                  </div>
                  <div className="flag__textline">
                    <span>Reason:</span> {splitFlagReason(flag.reason)}
                  </div>
                  {order && (
                    <div className="flag__textline">
                      <span>Order:</span>
                      {order.type === ("rescan" as LabOrder.type)
                        ? "Rescan"
                        : joinWithCommas(
                            order.lab_order_items
                              .map(
                                (labOrderItem) =>
                                  getStainByLabStainId(
                                    labOrderItem.lab_stain_id || 0,
                                    stains,
                                    labStains
                                  )?.abbreviation
                              )
                              .filter((i) => !!i) as string[]
                          )}
                      {order.cancelled_at && (
                        <p className="flag__warning">(Cancelled)</p>
                      )}
                      {order.completed_at && (
                        <p className="flag__success">(Completed)</p>
                      )}
                    </div>
                  )}
                  {flag.note && (
                    <p>
                      <span>Additional Details:</span> {flag.note}
                    </p>
                  )}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default FlagList;
